import { SET_RES_AVAILABLE_TIME } from '../actions';

const reservationtime = (state = [], action) => {
  switch (action.type) {
    case SET_RES_AVAILABLE_TIME:
      return [...action.value];
    default: return state;
  }
}

export default reservationtime;
